import React, { useEffect, useCallback } from 'react';
import { node } from 'prop-types';
import {
    useFeatureFlags,
    useLandingProduct,
    useGTM,
    useListingData,
} from 'hooks';
import { ProductBooster } from 'modules';
import { categoryShape } from 'shapes';
import { CategoryLocker, CategoryProvider } from './components';

const CategoryPage = ({ children, value }) => {
    const [
        { hasMerchandizingDetection, hasSponsoredProducts },
    ] = useFeatureFlags({
        hasMerchandizingDetection:
            'instantSearch.category.detection.merchandizing',
        hasSponsoredProducts: 'relevance.listing.sponsored.products',
    });
    const [modelId] = useLandingProduct();
    const [, pushToGTM] = useGTM();
    const { listingData } = useListingData();

    const setAncestorsInToDataLayer = useCallback(() => {
        if (listingData && listingData.params && listingData.params.context) {
            pushToGTM({
                ancestors: listingData.params.context.ancestors,
                ...(listingData.query && { search_query: listingData.query }),
            });
        }
    }, [pushToGTM, listingData.params.context.ancestors, listingData.query]);

    useEffect(() => setAncestorsInToDataLayer(), []);

    return (
        <CategoryProvider category={value}>
            <CategoryLocker />
            {children}
            {(hasMerchandizingDetection || hasSponsoredProducts) && (
                <ProductBooster
                    category={value}
                    modelId={modelId}
                    pageType="category"
                />
            )}
        </CategoryProvider>
    );
};

CategoryPage.propTypes = {
    children: node.isRequired,
    value: categoryShape.isRequired,
};

CategoryPage.displayName = 'CategoryPage';

export default CategoryPage;
